import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

export const getAdminUserAdminUrl = (state: IRootState) => state.admin.userAdminUrl;
export const getAdminFetchSettings = (state: IRootState) => state.admin.fetchSettings;
export const getAdminCatalogsForUpdate = (state: IRootState) => state.admin.catalogsForUpdate;
export const getAdminCatalogName = (state: IRootState) => state.admin.catalogName;
export const getAdminNews = (state: IRootState) => state.admin.news;
export const getAdminNewsPage = (state: IRootState) => state.admin.newsPage;
export const getAdminNewsOrder = (state: IRootState) => state.admin.newsOrder;
export const getAdminNewsPageCount = (state: IRootState) => state.admin.newsPageCount;
export const getAdminNewsTotalCount = (state: IRootState) => state.admin.newsTotalCount;
export const getAdminSystemInoperabilityList = (state: IRootState) => state.admin.systemInoperabilityList;
export const getAdminSystemInoperabilityOrder = (state: IRootState) => state.admin.systemInoperabilityListOrder;
export const getAdminSystemInoperabilityTotalCount = (state: IRootState) =>
  state.admin.systemInoperabilityListTotalCount;
export const getAdminSystemInoperabilityListPage = (state: IRootState) => state.admin.systemInoperabilityListPage;
export const getAdminSystemInoperabilityListIsShowSave = (state: IRootState) =>
  state.admin.systemInoperabilityListShowSave;
export const getAdminSystemInoperabilityListIsDisableSave = (state: IRootState) =>
  state.admin.systemInoperabilityListDisableSave;
export const getAdminSystemInoperabilityFormRef = (state: IRootState) => state.admin.systemInoperabilityFormRef;
export const getAdminSystemInoperabilityFormElementRef = (state: IRootState) =>
  state.admin.systemInoperabilityFormElementRef;
export const getAdminSystemInoperabilityFormUnsavedRecords = (state: IRootState) =>
  state.admin.systemInoperabilityFormUnsavedRecords;
export const getAdminControlOfNewslettersListPage = (state: IRootState) => state.admin.controlOfNewslettersListPage;
export const getAdminControlOfNewslettersList = (state: IRootState) => state.admin.controlOfNewslettersList;
export const getAdminControlOfNewslettersTotalCount = (state: IRootState) =>
  state.admin.controlOfNewslettersListTotalCount;
export const getAdminMangeTestUsersList = (state: IRootState) => state.admin.mangeTestUsersList;
export const getAdminMangeTestUsersListOrder = (state: IRootState) => state.admin.mangeTestUsersListOrder;
export const getAdminMangeTestUsersListTotalCount = (state: IRootState) => state.admin.mangeTestUsersListTotalCount;
export const getAdminMangeTestUsersListPage = (state: IRootState) => state.admin.mangeTestUsersListPage;
